<template lang="pug">
  nav
    ul
      li
         router-link(to="/") Home
      li
        router-link(to="/some") Some
      li
        router-link(to="/more") More
      li
        router-link(to="/nav") Nav
      li
        router-link(to="/items") Items
</template>
<script>
export default {
  name: 'AppNav'
};
</script>
<style lang="scss" scoped>
nav {
  position: absolute;
  display: block;
  left: 200px;
  right: 0;
  bottom: 0;

  .router-link-exact-active {
    background: #9F1002;
    border: 1px solid black;
  }

  ul {
    display: flex;
    flex-direction: row;
    list-style: none;

    li a{
      display: block;
      padding: 15px;
      color: white;
      text-decoration: none;
      font-size: 30px;
      border: 1px solid transparent;

      &:hover{
        background: #9F1002;
        border: 1px solid black;
      }
    }
  }
}
</style>

